import { Helmet } from "react-helmet-async";

function About() {
  return (
    <div className="max-w-3xl mx-auto p-6 text-gray-800">
      {/* 🔹 SEO Meta Tags */}
      <Helmet>
        <title>About Us - Build Pro Resume</title>
        <meta
          name="description"
          content="Learn more about Build Pro Resume, a free platform that helps job seekers create professional, ATS-friendly resumes in minutes."
        />
        <meta name="robots" content="index, follow" />
      </Helmet>

      {/* 🔹 About Section */}
      <h1 className="text-3xl font-bold mb-4">About Us</h1>
      <p className="mb-4">
        <strong>Build Pro Resume</strong> is a free and easy-to-use
        resume-building platform designed to help job seekers create
        professional, ATS-friendly resumes in minutes.
      </p>
      <p className="mb-4">
        We believe that crafting a standout resume shouldn't be complicated. Our
        mission is to simplify the process and empower users with a seamless,
        user-friendly experience—no design skills needed.
      </p>
      <p>
        <strong>Be an early user!</strong> Your feedback will help shape Build
        Pro Resume into the #1 free resume tool for job seekers worldwide. 🚀
      </p>
    </div>
  );
}

export default About;
